<div class="report-card">
  <div class="header">
    Quote Stats
    <span class="sub-header">
      {{ startDate | date: 'shortDate' }} - {{ endDate | date: 'shortDate' }}
      @if (employee && !companyWide) {
        <span>, {{employee.fullName}}</span>
      }
      @if (companyWide) {
        <span>, All</span>
      }
    </span>
  </div>
  <app-loading-swirly [isLoading]="statsLoading"></app-loading-swirly>

  @if (!statsLoading) {
    <div style="display: flex; justify-content: space-evenly;">
      <div class="big-header">
        {{quoteStats.sent}}
        <div class="small">
          Sent
        </div>
      </div>
      <div class="big-header">
        {{quoteStats.opened}}
        <div class="small">
          Opened
        </div>
      </div>
      <div class="big-header and-blue">
        {{quoteStats.signed}}
        <div class="small">
          Signed
        </div>
      </div>
    </div>
  }
  <canvas id="chartJSContainer"></canvas>
</div>
